import { Moon, Sun } from "lucide-react";
import { useLang } from "../i18n";

const ThemeToggle = ({ theme, onToggle, className = "", compact = false }) => {
  const { t } = useLang();
  return (
    <div className={`flex flex-col items-center gap-1 ${className}`}>
      <button
        type="button"
        onClick={onToggle}
        aria-label={theme === "light" ? "Switch to dark theme" : "Switch to light theme"}
        data-testid="theme-toggle"
        className={`flex items-center justify-center rounded-full border border-white/15 text-white transition-colors duration-300 hover:border-cyan-300/50 ${compact ? "h-9 w-9" : "h-10 w-10"}`}
      >
        {theme === "light" ? <Moon className={compact ? "h-4 w-4" : "h-5 w-5"} /> : <Sun className={compact ? "h-4 w-4" : "h-5 w-5"} />}
      </button>
      <span className="hidden text-[9px] font-medium uppercase tracking-[0.12em] text-white/40 lg:block">
        {t("ui.theme", "Theme")}
      </span>
    </div>
  );
};

export default ThemeToggle;
